export const SET_PROFILE_VIEWS = 'SET_PROFILE_VIEWS'
export const REFRESH_PROFILE_VIEWS = 'REFRESH_PROFILE_VIEWS'
